module.exports = __webpack_public_path__ + "img/replay.69c3d6c7.png";